import _ from 'lodash';
import { AxiosError } from 'axios';
import { observable, action } from 'mobx';

import DocumentListItem from '../Models/DocumentListItem';
import NzfapCertificate from '../Models/NzfapCertificate';
import { TelemetryExceptionType } from '../Constants/Telemetry';
import DocumentService from '../Services/DocumentService';

class DocumentStore {
  @observable public docList: Array<DocumentListItem>;
  @observable public isDocListLoaded: boolean;
  @observable public isDocListAllLoaded: boolean;
  @observable public isDocListLoadError: boolean;


  private _docService: DocumentService = new DocumentService();
  private _docListPage = 1;

  constructor() {
    this.isDocListAllLoaded = false;
  }

  @action
  getNZFAPDocumentList = async () => {
    this.isDocListLoadError = false;

    try {
          const response = await this._docService.getNZFAPDocumentsList(this._docListPage);
          const newPage = this._docListPage + 1;

          if(response!.data.searchResults.length == 0){
            this.isDocListAllLoaded = true;
          }

          if(!this.docList){
          this.docList = response!.data.searchResults;
          this._docListPage = newPage;
          }
          else {
            this.docList.push(...response!.data.searchResults);
          this._docListPage = newPage;
          }
          this.isDocListLoaded = true;
      } catch (error) {
          //window.telemetry.logException(error, TelemetryExceptionType.ApiError);
          this.isDocListLoadError = true;
          this.isDocListLoaded = true;
      }
  }

   getNZFAPDocument = async (docId: string) => {
    return this._docService.getSingleDocument(docId);      
  }

  }

export default DocumentStore;
